import 'ol/ol.css';
import 'fontawesome-iconpicker/dist/css/fontawesome-iconpicker.min.css';
import 'fontawesome-iconpicker/dist/js/fontawesome-iconpicker.min.js';
import '@fortawesome/fontawesome-free/css/all.css';
import "ol-ext/dist/ol-ext.css";
import FillPattern from 'ol-ext/style/FillPattern';
import $ from 'jquery';
import { transform } from "ol/proj";
import Dialog from 'ol-ext/control/Dialog';
import axios from "axios";
import logger from '../logger';
import { fetchSources, fetchLayers, fetchSourceParameters, fetchLanguages, fetchFeatures } from '../services/api';
import api from '../services/auth';
import "../App.css";


function isInEPSG4326(coords) {
  const [lon, lat] = coords;
  logger.log("is EPSG 4326: ", (lon >= -180 && lon <= 180 && lat >= -90 && lat <= 90));
  return lon >= -180 && lon <= 180 && lat >= -90 && lat <= 90;
};

function makeDialogDraggable(dialogElement) {
  let isMouseDown = false;
  let offset = [0, 0];

  const handleMouseDown = (e) => {
    // Prevent dragging if interacting with buttons or form elements
    if (['INPUT', 'TEXTAREA', 'BUTTON', 'SELECT'].includes(e.target.tagName)) return;

    isMouseDown = true;
    offset = [
      dialogElement.offsetLeft - e.clientX,
      dialogElement.offsetTop - e.clientY
    ];
    dialogElement.style.cursor = 'move';
  };

  const handleMouseUp = () => {
    isMouseDown = false;
    dialogElement.style.cursor = 'default';
  };

  const handleMouseMove = (e) => {
    if (!isMouseDown) return;

    const mousePosition = {
      x: e.clientX,
      y: e.clientY
    };
    dialogElement.style.left = (mousePosition.x + offset[0]) + 'px';
    dialogElement.style.top = (mousePosition.y + offset[1]) + 'px';
  };

  // Attach event listeners
  dialogElement.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mouseup', handleMouseUp);
  document.addEventListener('mousemove', handleMouseMove);

  // Clean up function to avoid memory leaks
  return () => {
    dialogElement.removeEventListener('mousedown', handleMouseDown);
    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('mousemove', handleMouseMove);
  };
};

function makeDialogResizable(dialogElement) {
  const resizer = document.createElement('div');
  resizer.style.width = '10px';
  resizer.style.height = '10px';
  resizer.style.background = 'rgba(0, 0, 0, 0.2)';
  resizer.style.position = 'absolute';
  resizer.style.right = '0';
  resizer.style.bottom = '0';
  resizer.style.cursor = 'se-resize';
  dialogElement.appendChild(resizer);

  const handleResizeMouseDown = (e) => {
    e.preventDefault(); // Prevent text selection and other default actions

    window.addEventListener('mousemove', handleResizeMouseMove);
    window.addEventListener('mouseup', handleResizeMouseUp);
  };

  const handleResizeMouseMove = (e) => {
    dialogElement.style.width = e.clientX - dialogElement.offsetLeft + 'px';
    dialogElement.style.height = e.clientY - dialogElement.offsetTop + 'px';
  };

  const handleResizeMouseUp = () => {
    window.removeEventListener('mousemove', handleResizeMouseMove);
    window.removeEventListener('mouseup', handleResizeMouseUp);
  };

  // Attach event listener for resizing
  resizer.addEventListener('mousedown', handleResizeMouseDown);

  // Clean up function to avoid memory leaks
  return () => {
    resizer.removeEventListener('mousedown', handleResizeMouseDown);
  };
};

// function conditionalField(visibilitySelect) {
//   let selectedValue = visibilitySelect.value;
//   let conditionalField = document.getElementById('conditional-field');

//   if (selectedValue === 'private') {
//     conditionalField.style.display = 'block'; // Show the conditional field if 'private' is selected
//   } else if (conditionalField) {
//     conditionalField.style.display = 'none'; // Hide the conditional field for other selections
//   };
// };

function getFeatureGeometry(feature) {
  // Check if the geometry is directly accessible or nested within 'values_'
  if (feature.getGeometry) {
    return feature.getGeometry();
  } else if (feature.values_ && feature.values_.geometry) {
    return feature.values_.geometry;
  } else {
    logger.error('Unable to access feature geometry');
    return null; // Or handle this case as appropriate for your application
  };
};

// Function to perform reverse geocoding
// const fetchAddress = async (coords) => {
//   logger.log("coords address: ", coords);

//   const url = `${process.env.REACT_APP_NOMINATIM_API}/reverse?format=json&lat=${coords[1]}&lon=${coords[0]}&zoom=18&addressdetails=1`;

//   try {
//     const response = await axios.get(url);
//     logger.log("response: ", response);
//     return response.data.display_name; // Return the full address
//   } catch (error) {
//     logger.error("Error fetching address:", error);
//     return '';
//   };
// };

let hasRun = false;

export async function generateDialog(map, featureOrEvent, featureStyles, setFeatures, context, selectToEdit, selectToViewRef, editToggle) {

  if(hasRun) return;

  hasRun = true;
    
  logger.log("setFeatures type: ", typeof setFeatures);
  const languages = await fetchLanguages();
  const sources = await fetchSources();
  const sourceParameters = await fetchSourceParameters();

  logger.log("languages: ", languages);

  let feature = featureOrEvent.feature ? featureOrEvent.feature : featureOrEvent; // Get the feature that was just drawn

  logger.log("Feature or Event inside dialog: ", featureOrEvent);

  let coords = feature.getGeometry().getCoordinates(); // Get the coordinates of the drawn point
  logger.log("coords value at start of dialog: ", coords);

  logger.log("Feature inside dialog: ", feature.getGeometry().getType());

  // Check if transformation is needed based on the geometry type
  if (feature.getGeometry().getType() === 'Polygon') {
    logger.log("polygon coords before transform: ", coords);
    // Transform only if not already in EPSG:4326
    if (!isInEPSG4326(coords)) {
      coords = coords[0].map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
    };
  } else if (feature.getGeometry().getType() === 'LineString') {
    logger.log('line string coords before transform: ', coords);
    // Example for LineString, similar logic can be applied as for Polygon
    if (!isInEPSG4326(coords)) {
      coords = coords.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
    };
  } else {
    logger.log("point coords before transform: ", coords);
    // For points or other geometries
    if (!isInEPSG4326(coords)) {
      coords = transform(coords, 'EPSG:3857', 'EPSG:4326');
    };
  };

  logger.log("coords after transform: ", coords);

  // Get the existing validFrom and validTo values
  const validFrom = featureOrEvent.values_?.validFrom || '';
  const validTo = featureOrEvent.values_?.validTo || '';

  // Define the dialog content with a custom "X" button
  let geometry = getFeatureGeometry(feature); // Utility function to handle different feature structures
  let featureType = geometry.getType();
  logger.log("Generating dialog content for feature type:", featureType);


  const dialogContent = `
  <div class="row">    
      <div class="save-btn" style="position: absolute; top: 5px; right: 50px; cursor: pointer;" id="save-feature"><i class="fas fa-save"></i></div>
      <div class="cancel-btn" style="position: absolute; top: 5px; right: 20px; cursor: pointer;" id="cancel-feature"><i class="fas fa-times"></i></div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="title">Title</label>
    </div>
    <div class="col-75">
      <input type="text" id="title" name="title" placeholder="Title..">
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="valid-from">Valid From</label>
    </div>
    <div class="col-25">
      <input style="margin:10px;" type="date" id="valid-from" name="validFrom" value="${validFrom}">
    </div>
    <div class="col-25">
      <label for="valid-to">Valid To</label>
    </div>
    <div class="col-25">
      <input style="margin:10px;" type="date" id="valid-to" name="validTo" value="${validTo}">
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="sources">Sources:</label>
    </div>
    <div class="col-75 dual-listbox">
      <div class="listbox">
        <h4>Available Sources</h4>
        <ul id="available-sources"></ul>
      </div>
      <div class="listbox-buttons">
        <button type="button" id="add-source">&gt;</button>
        <button type="button" id="remove-source">&lt;</button>
      </div>
      <div class="listbox">
        <h4>Selected Sources</h4>
        <ul id="selected-sources"></ul>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="description">Description</label>
    </div>
    <div class="col-75">
      <textarea id="description" name="description" placeholder="Description.." style="height:150px"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="address">Address</label>
    </div>
    <div class="col-75">
      <input type="text" id="address" name="address" placeholder="Address..">
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="contact">Contact</label>
    </div>
    <div class="col-75">
      <input type="text" id="contact" name="contact" placeholder="Contact..">
    </div>
  </div>
  `;

  // <div class="row" id="conditional-field" style="display:none; transition: display 2s;">
  //   <div class="col-25">
  //     <label for="sub-category">Sub-Category</label>
  //   </div>
  //   <div class="col-75">
  //     <select id="subCategory" name="subCategory">
  //       <option value="forester">Forester</option>
  //       <option value="forest ranger">Forest ranger</option>
  //       <option value="fire fighter">Fire fighter</option>
  //       <option value="doctor">Doctor</option>
  //       <option value="medic">Medic</option>
  //       <option value="civil protection">Civil protection</option>
  //     </select>
  //   </div>
  // </div>

  //   <div class="row">
  //   <div class="col-25">
  //     <label for="language">Language:</label>
  //   </div>
  //   <div class="col-75">
  //       <select id="language" name="language">
  //         ${languages.map(language => `<option value="${language.id}">${language.title}</option>`).join('')}
  //       </select>
  //   </div>
  // </div>

  // Create a new Dialog instance
  let layerDialog = new Dialog({
    className: "feature-dialog",
    content: dialogContent,
    closeBox: false,
  });

  map.addControl(layerDialog);
  layerDialog.show();  // Show the dialog

  // Make the dialog draggable
  makeDialogDraggable(layerDialog.element);
  makeDialogResizable(layerDialog.element);  // Make it resizable

  // let visibilitySelect = document.getElementById('visibility');
  if (context === "edit") {
    document.getElementById('title').value = featureOrEvent.values_.title || '';
    // document.getElementById('source').value = featureOrEvent.values_.sources || '';
    document.getElementById('valid-from').value = featureOrEvent.values_.valid_from || '';
    document.getElementById('valid-to').value = featureOrEvent.values_.valid_to || '';
    // document.getElementById('subCategory').value = featureOrEvent.values_.subCategory || '';
    document.getElementById('description').value = featureOrEvent.values_.description || '';
    document.getElementById('address').value = featureOrEvent.values_.address || '';
    document.getElementById('contact').value = featureOrEvent.values_.contact || '';

    // conditionalField(visibilitySelect);
    // visibilitySelect.addEventListener('change', function() {
    //   conditionalField(visibilitySelect);
    // });
  };

  const availableSources = document.getElementById('available-sources');
  const selectedSources = document.getElementById('selected-sources');
  const addSourceButton = document.getElementById('add-source');
  const removeSourceButton = document.getElementById('remove-source');

  logger.log("source params: ", sourceParameters);

  const vectorSourceType = sourceParameters.source_types.find(type => type.title === "Vector (Vector)");

  sources.forEach(source => {
    if (source.type === vectorSourceType.id && source.is_enabled === true) { // Filter only enabled sources
      const li = document.createElement('li');
      li.textContent = source.title;
      li.dataset.id = source.id;
      availableSources.appendChild(li);
    }
  });

  // Function to clear all selections in both source lists
  const clearSelections = () => {
    [availableSources, selectedSources].forEach(list => {
      list.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
    });
  };

  // Function to move a source to the selected list
  const handleAddSource = (sourceElement) => {
    selectedSources.appendChild(sourceElement);
    clearSelections();
  };

  // Function to move a source back to the available list
  const handleRemoveSource = (sourceElement) => {
    availableSources.appendChild(sourceElement);
    clearSelections();
  };

  // Event listeners for add and remove buttons
  addSourceButton.addEventListener('click', () => {
    const selected = availableSources.querySelector('li.selected');
    if (selected) {
      handleAddSource(selected);
    }
  });

  removeSourceButton.addEventListener('click', () => {
    const selected = selectedSources.querySelector('li.selected');
    if (selected) {
      handleRemoveSource(selected);
    }
  });

  // Click handler to mark a source as selected
  [availableSources, selectedSources].forEach(list => {
    list.addEventListener('click', (e) => {
      if (e.target.tagName === 'LI') {
        list.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        e.target.classList.add('selected');
      }
    });
  });

  if (context === 'edit' && featureOrEvent.values_.sources) {
    const existingSourceIds = featureOrEvent.values_.sources.map(id => String(id)); // Convert to strings

    // Iterate over all sources to ensure even non-enabled ones are accounted for
    sources.forEach(source => {
        if (existingSourceIds.includes(String(source.id))) {
            const li = availableSources.querySelector(`li[data-id="${source.id}"]`);
            if (li) {
                selectedSources.appendChild(li); // Move to selected if it exists in the available list
            } else if (source.is_enabled !== true) {
                // Handle cases where source is not enabled (optional, e.g., display a warning or add it temporarily)
                const tempLi = document.createElement('li');
                tempLi.textContent = source.title;
                tempLi.dataset.id = source.id;
                tempLi.classList.add('disabled'); // Optionally mark it visually as disabled
                selectedSources.appendChild(tempLi);
            }
        }
    });
  }

  async function saveFeatureHandler() {
    const title = document.getElementById('title').value;
    const description = document.getElementById('description').value;
    const address = document.getElementById('address').value;
    const contact = document.getElementById('contact').value;
    const validFrom = document.getElementById('valid-from').value || new Date().toISOString().slice(0, 10);
    const validTo = document.getElementById('valid-to').value || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().slice(0, 10);

    let featureId;
    if (context === "edit") {
        featureId = feature.values_.id;
    }

    const selectedSourceIds = Array.from(selectedSources.children).map(li => li.dataset.id);
    const featureType = feature.getGeometry().getType();

    logger.log("coords value at end of dialog: ", coords);

    const newFeature = {
      geometry: {
          type: featureType,
          coordinates: featureType === "Polygon" ? [coords] : coords
      },
      is_enabled: true,
      title: title,
      description: description,
      address: address,
      contact: contact,
      image: null,
      origin: "GUI",
      valid_from: validFrom,
      valid_to: validTo,
      sources: selectedSourceIds,
      viewers: []
    };

    logger.log("new feature: ", JSON.stringify(newFeature, null, 2));

    try {
        await handleAddFeatureSave(newFeature, featureId, context);
        if (layerDialog) {
          layerDialog.hide();
          map.removeControl(layerDialog);  // Remove it from the map
          layerDialog = null;  // Reset reference
        };

        if (editToggle) {
          editToggle.setActive(false);
          logger.log("editToggle has been deactivated.");
        };

        // **Ensure selectToEdit is removed when closing dialog**
        if (selectToEdit) {
          map.removeInteraction(selectToEdit);
          logger.log("selectToEdit has been removed from map.");
        };

        // **Ensure selectToView is added back to avoid UI being stuck**
        if (selectToViewRef) {
          map.addInteraction(selectToViewRef);
          logger.log("selectToView has been reactivated.");
        };

        const updatedFeatures = await fetchFeatures();
        setFeatures(updatedFeatures);

        feature = null ; //Reset feature
        logger.log("layerDialog: ", layerDialog);
        hasRun = false;
    } catch (error) {
      hasRun = false;
      logger.error('Error saving new feature:', error);
    }
  };

  function cancelFeatureHandler() {
    if (layerDialog) {
        layerDialog.hide();
        map.removeControl(layerDialog);  // Remove it from the map
        layerDialog = null;  // Reset reference
        feature = null ; //Reset feature

        // **Ensure selectToEdit is removed when closing dialog**
        if (selectToEdit) {
          map.removeInteraction(selectToEdit);
          logger.log("selectToEdit has been removed from map.");
        };

        // **Ensure selectToView is added back to avoid UI being stuck**
        if (selectToViewRef) {
          map.addInteraction(selectToViewRef);
          logger.log("selectToView has been reactivated.");
        };

        if (editToggle) {
          editToggle.setActive(false);
          logger.log("editToggle has been deactivated.");
        }
        hasRun = false;
    } else {
        hasRun = false;
        console.warn("layerDialog is already null or undefined");
    }
  };

  // Attach the event listeners
  const saveButton = document.getElementById('save-feature');
  const cancelButton = document.getElementById('cancel-feature');

  if (saveButton) {
    saveButton.removeEventListener('click', saveFeatureHandler);
    saveButton.addEventListener('click', saveFeatureHandler);
  }

  if (cancelButton) {
    cancelButton.removeEventListener('click', cancelFeatureHandler);
    cancelButton.addEventListener('click', cancelFeatureHandler);
  }  
};

// export async function generateDialog(map, featureOrEvent, featureStyles, setFeatures, context, selectToEdit) {
//   logger.log("setFeatures type: ", typeof setFeatures);
//   const languages = await fetchLanguages();
//   const sources = await fetchSources();
//   const sourceParameters = await fetchSourceParameters();

//   let feature = featureOrEvent.feature ? featureOrEvent.feature : featureOrEvent;
//   let coords = feature.getGeometry().getCoordinates();

//   if (feature.getGeometry().getType() === 'Polygon') {
//     if (!isInEPSG4326(coords)) {
//       coords = coords[0].map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
//     }
//   } else if (feature.getGeometry().getType() === 'LineString') {
//     if (!isInEPSG4326(coords)) {
//       coords = coords.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
//     }
//   } else {
//     if (!isInEPSG4326(coords)) {
//       coords = transform(coords, 'EPSG:3857', 'EPSG:4326');
//     }
//   }

//   const validFrom = featureOrEvent.values_?.validFrom || '';
//   const validTo = featureOrEvent.values_?.validTo || '';

//   // Create the dialog container
//   const dialogContainer = document.createElement('div');
//   dialogContainer.className = 'custom-dialog';
//   dialogContainer.innerHTML = `
//     <div class="dialog-header">
//       <button class="dialog-close" id="cancel-feature">&times;</button>
//       <button class="dialog-save" id="save-feature">Save</button>
//     </div>
//     <div class="dialog-content">
//       <div class="form-group">
//         <label for="title">Title</label>
//         <input type="text" id="title" placeholder="Title.." />
//       </div>
//       <div class="form-group">
//         <label for="valid-from">Valid From</label>
//         <input type="date" id="valid-from" value="${validFrom}" />
//       </div>
//       <div class="form-group">
//         <label for="valid-to">Valid To</label>
//         <input type="date" id="valid-to" value="${validTo}" />
//       </div>
//       <div class="form-group">
//         <label for="sources">Sources</label>
//         <div class="dual-listbox">
//           <div class="listbox available">
//             <h4>Available Sources</h4>
//             <ul id="available-sources"></ul>
//           </div>
//           <div class="listbox-buttons">
//             <button id="add-source">&gt;</button>
//             <button id="remove-source">&lt;</button>
//           </div>
//           <div class="listbox selected">
//             <h4>Selected Sources</h4>
//             <ul id="selected-sources"></ul>
//           </div>
//         </div>
//       </div>
//       <div class="form-group">
//         <label for="description">Description</label>
//         <textarea id="description" placeholder="Description.."></textarea>
//       </div>
//       <div class="form-group">
//         <label for="address">Address</label>
//         <input type="text" id="address" placeholder="Address.." />
//       </div>
//       <div class="form-group">
//         <label for="contact">Contact</label>
//         <input type="text" id="contact" placeholder="Contact.." />
//       </div>
//     </div>
//   `;

//   document.body.appendChild(dialogContainer);

//   const availableSources = document.getElementById('available-sources');
//   const selectedSources = document.getElementById('selected-sources');
//   const addSourceButton = document.getElementById('add-source');
//   const removeSourceButton = document.getElementById('remove-source');

//   const vectorSourceType = sourceParameters.source_types.find(type => type.title === "Vector (Vector)");

//   sources.forEach(source => {
//     if (source.type === vectorSourceType.id && source.is_enabled) {
//       const li = document.createElement('li');
//       li.textContent = source.title;
//       li.dataset.id = source.id;
//       availableSources.appendChild(li);
//     }
//   });

//   const clearSelections = () => {
//     [availableSources, selectedSources].forEach(list => {
//       list.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
//     });
//   };

//   const handleAddSource = (sourceElement) => {
//     selectedSources.appendChild(sourceElement);
//     clearSelections();
//   };

//   const handleRemoveSource = (sourceElement) => {
//     availableSources.appendChild(sourceElement);
//     clearSelections();
//   };

//   addSourceButton.addEventListener('click', () => {
//     const selected = availableSources.querySelector('li.selected');
//     if (selected) {
//       handleAddSource(selected);
//     }
//   });

//   removeSourceButton.addEventListener('click', () => {
//     const selected = selectedSources.querySelector('li.selected');
//     if (selected) {
//       handleRemoveSource(selected);
//     }
//   });

//   [availableSources, selectedSources].forEach(list => {
//     list.addEventListener('click', (e) => {
//       if (e.target.tagName === 'LI') {
//         list.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
//         e.target.classList.add('selected');
//       }
//     });
//   });

//   if (context === 'edit' && featureOrEvent.values_.sources) {
//     const existingSourceIds = featureOrEvent.values_.sources.map(id => String(id));

//     sources.forEach(source => {
//       if (existingSourceIds.includes(String(source.id))) {
//         const li = availableSources.querySelector(`li[data-id="${source.id}"]`);
//         if (li) {
//           selectedSources.appendChild(li);
//         } else if (!source.is_enabled) {
//           const tempLi = document.createElement('li');
//           tempLi.textContent = source.title;
//           tempLi.dataset.id = source.id;
//           tempLi.classList.add('disabled');
//           selectedSources.appendChild(tempLi);
//         }
//       }
//     });
//   }

//   document.getElementById('save-feature').addEventListener('click', async () => {
//     const title = document.getElementById('title').value;
//     const description = document.getElementById('description').value;
//     const address = document.getElementById('address').value;
//     const contact = document.getElementById('contact').value;
//     const validFrom = document.getElementById('valid-from').value || new Date().toISOString().slice(0, 10);
//     const validTo = document.getElementById('valid-to').value || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().slice(0, 10);

//     const selectedSourceIds = Array.from(selectedSources.children).map(li => li.dataset.id);
//     const featureType = feature.getGeometry().getType();

//     const newFeature = {
//       geometry: {
//         type: featureType,
//         coordinates: featureType === "Polygon" ? [coords] : coords
//       },
//       is_enabled: true,
//       title,
//       description,
//       address,
//       contact,
//       image: null,
//       origin: "GUI",
//       valid_from: validFrom,
//       valid_to: validTo,
//       sources: selectedSourceIds,
//       viewers: []
//     };

//     try {
//       await handleAddFeatureSave(newFeature, feature.values_.id, context);
//       document.body.removeChild(dialogContainer);

//       const updatedFeatures = await fetchFeatures();
//       setFeatures(updatedFeatures);
//     } catch (error) {
//       logger.error('Error saving new feature:', error);
//     }
//   });

//   document.getElementById('cancel-feature').addEventListener('click', () => {
//     document.body.removeChild(dialogContainer);
//   });
// }

async function handleAddFeatureSave(newFeature, featureId, context) {
  try {
    let response;
    if (context !== "edit") {
      response = await api.post('/map/feature/', newFeature);
    } else if (context === "edit") {
      response = await api.patch(`/map/feature/${featureId}/`, newFeature);
    }
    if (response.status !== 201 && response.status !== 200) throw new Error('Failed to save source');
  } catch (error) {
    logger.error('Error saving new source:', error);
    throw error;
  }
}

//**************************************************************************************
//**************************************************************************************
//File Upload
//**************************************************************************************
//**************************************************************************************

export async function handleFileUploadDialog(map, features, setFeatures) {
  logger.log("Starting file upload process with features:", features);

  // Fetch necessary data for the dialog (languages, sources, etc.)
  // const languages = await fetchLanguages();
  const sources = await fetchSources();
  const sourceParameters = await fetchSourceParameters();

  // Create the dialog (same as in generateDialog)
  const dialogContent = `
  <div class="row">
    <div class="save-btn" style="position: absolute; top: 5px; right: 50px; cursor: pointer;" id="save-feature"><i class="fas fa-save"></i></div>
    <div class="cancel-btn" style="position: absolute; top: 5px; right: 20px; cursor: pointer;" id="cancel-feature"><i class="fas fa-times"></i></div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="title">Title</label>
    </div>
    <div class="col-75">
      <input type="text" id="title" name="title" placeholder="Title..">
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="valid-from">Valid From</label>
    </div>
    <div class="col-25">
      <input style="margin:0px;" type="date" id="valid-from" name="validFrom" value="">
    </div>
    <div class="col-25">
      <label for="valid-to">Valid To</label>
    </div>
    <div class="col-25">
      <input style="margin-top:0px;" type="date" id="valid-to" name="validTo" value="">
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="sources">Sources:</label>
    </div>
    <div class="col-75 dual-listbox">
      <div class="listbox">
        <h4>Available Sources</h4>
        <ul id="available-sources"></ul>
      </div>
      <div class="listbox-buttons">
        <button type="button" id="add-source">&gt;</button>
        <button type="button" id="remove-source">&lt;</button>
      </div>
      <div class="listbox">
        <h4>Selected Sources</h4>
        <ul id="selected-sources"></ul>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="description">Description</label>
    </div>
    <div class="col-75">
      <textarea id="description" name="description" placeholder="Description.." style="height:150px"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="address">Address</label>
    </div>
    <div class="col-75">
      <input type="text" id="address" name="address" placeholder="Address..">
    </div>
  </div>
  <div class="row">
    <div class="col-25">
      <label for="contact">Contact</label>
    </div>
    <div class="col-75">
      <input type="text" id="contact" name="contact" placeholder="Contact..">
    </div>
  </div>
  `;

  let layerDialog = new Dialog({
    content: dialogContent,
    className: "upload-dialog",
    closeBox: false,
  });

  map.addControl(layerDialog);
  layerDialog.show();  // Show the dialog

  // Make the dialog draggable
  makeDialogDraggable(layerDialog.element);
  makeDialogResizable(layerDialog.element);  // Make it resizable

  const availableSources = document.getElementById('available-sources');
  const selectedSources = document.getElementById('selected-sources');
  const addSourceButton = document.getElementById('add-source');
  const removeSourceButton = document.getElementById('remove-source');

  const vectorSourceType = sourceParameters.source_types.find(type => type.title === "Vector (Vector)");

  sources.forEach(source => {
    if (source.type === vectorSourceType.id && source.is_enabled === true) { // Filter only enabled sources
      const li = document.createElement('li');
      li.textContent = source.title;
      li.dataset.id = source.id;
      availableSources.appendChild(li);
    }
  });

  // Function to clear all selections in both source lists
  const clearSelections = () => {
    [availableSources, selectedSources].forEach(list => {
      list.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
    });
  };

  // Function to move a source to the selected list
  const handleAddSource = (sourceElement) => {
    selectedSources.appendChild(sourceElement);
    clearSelections();
  };

  // Function to move a source back to the available list
  const handleRemoveSource = (sourceElement) => {
    availableSources.appendChild(sourceElement);
    clearSelections();
  };

  // Event listeners for add and remove buttons
  addSourceButton.addEventListener('click', () => {
    const selected = availableSources.querySelector('li.selected');
    if (selected) {
      handleAddSource(selected);
    }
  });

  removeSourceButton.addEventListener('click', () => {
    const selected = selectedSources.querySelector('li.selected');
    if (selected) {
      handleRemoveSource(selected);
    }
  });

  // Click handler to mark a source as selected
  [availableSources, selectedSources].forEach(list => {
    list.addEventListener('click', (e) => {
      if (e.target.tagName === 'LI') {
        list.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        e.target.classList.add('selected');
      }
    });
  });

  // Function to extract properties from the dialog
  const extractDialogProperties = () => {
    return {
      title: document.getElementById('title').value,
      description: document.getElementById('description').value,
      address: document.getElementById('address').value,
      contact: document.getElementById('contact').value,
      validFrom: document.getElementById('valid-from').value || new Date().toISOString().slice(0, 10),
      validTo: document.getElementById('valid-to').value || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().slice(0, 10),
      selectedSourceIds: Array.from(selectedSources.children).map(li => li.dataset.id),
    };
  };

  const processCoordinates = (coords, featureType) => {
    // Check if transformation is needed based on the geometry type
    if (featureType === 'Polygon' || featureType === 'MultiPolygon') {
      logger.log("polygon/multipolygon coords before transform: ", coords);

      // Check if it's a MultiPolygon
      if (featureType === 'MultiPolygon') {
        coords = coords.map(polygon => {
          return polygon[0].map(coord => {
            return !isInEPSG4326(coord) ? transform(coord, 'EPSG:3857', 'EPSG:4326') : coord;
          }).map(coord => coord.slice(0, 2));  // Remove third coordinate if exists
        });
      } else {
        // Handle single Polygon
        if (!isInEPSG4326(coords[0][0])) {
          coords = coords[0].map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
        }
        coords = coords.map(coord => coord.slice(0, 2));  // Remove third coordinate if exists
      }
      logger.log("polygon/multipolygon coords after transform: ", coords);
      return coords; // Return transformed coordinates

    } else if (featureType === 'LineString' || featureType === 'MultiLineString') {
      logger.log('line string/multilinestring coords before transform: ', coords);

      // Check if it's a MultiLineString
      if (featureType === 'MultiLineString') {
        coords = coords.map(lineString => {
          return lineString.map(coord => {
            return !isInEPSG4326(coord) ? transform(coord, 'EPSG:3857', 'EPSG:4326') : coord;
          }).map(coord => coord.slice(0, 2));  // Remove third coordinate if exists
        });
      } else {
        // Handle single LineString
        if (!isInEPSG4326(coords[0])) {
          coords = coords.map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
        }
        coords = coords.map(coord => coord.slice(0, 2));  // Remove third coordinate if exists
      }

      logger.log('line string/multilinestring coords after transform: ', coords);
      return coords; // Return transformed coordinates

    } else if (featureType === 'Point' || featureType === 'MultiPoint') {
      logger.log("point/multipoint coords before transform: ", coords);

      // Handle MultiPoint
      if (featureType === 'MultiPoint') {
        coords = coords.map(coord => {
          return !isInEPSG4326(coord) ? transform(coord, 'EPSG:3857', 'EPSG:4326') : coord;
        }).map(coord => coord.slice(0, 2));  // Remove third coordinate if exists
      } else {
        // Handle single Point
        if (!isInEPSG4326(coords)) {
          coords = transform(coords, 'EPSG:3857', 'EPSG:4326');
        }
        coords = coords.slice(0, 2);  // Remove third coordinate if exists
      }

      logger.log("point/multipoint coords after transform: ", coords);
      return coords; // Return transformed coordinates
    }
  };

  // Save button click handler
  document.getElementById('save-feature').addEventListener('click', async () => {
    const properties = extractDialogProperties(); // Extract common properties from dialog

    const saveButton = document.getElementById('save-feature');
    const spinner = document.createElement('div');
    spinner.className = 'uploader';
    saveButton.parentElement.appendChild(spinner); // Add spinner next to save button

    const errorMessage = document.createElement('p');
    errorMessage.className = 'error-message';
    errorMessage.style.color = '#FF3D00';
    errorMessage.style.display = 'none';
    saveButton.parentElement.appendChild(errorMessage);

    try {
      let counter = 0;

      // Loop through each feature and save it individually
      for (const feature of features) {
        let coords = feature.getGeometry().getCoordinates();
        const featureType = feature.getGeometry().getType();
        coords = processCoordinates(coords, featureType);

        let title;
        if (counter === 0) {
          title = properties.title;  // Use original title for the first feature
        } else {
          title = `${properties.title} (${counter})`;  // Append counter for subsequent features
        }

        const newFeature = {
          geometry: {
            type: featureType,
            coordinates: featureType === "Polygon" ? [coords] : coords,
          },
          is_enabled: true,
          title: feature.values_.name || title,
          description: properties.description,
          address: properties.address,
          contact: properties.contact,
          image: null,
          origin: "GUI",
          valid_from: properties.validFrom,
          valid_to: properties.validTo,
          sources: properties.selectedSourceIds,
          viewers: []
        };

        logger.log("new feature: ", JSON.stringify(newFeature, null, 2));

        await handleUploadFeature(newFeature, null, "fileUpload");  // Save each feature

        counter++;
      }

      // Fetch updated features and update the state
      const updatedFeatures = await fetchFeatures();
      setFeatures(updatedFeatures);

      // Close the dialog after saving

      map.removeControl(layerDialog);

    } catch (error) {
      logger.error('Error saving features:', error);
      spinner.style.display = 'none'; // Hide spinner
      errorMessage.textContent = 'Failed to save the feature. Please try again.';
      errorMessage.style.display = 'block';
    } finally {
      spinner.style.display = 'none';
    }
  });

  // Cancel button click handler
  document.getElementById('cancel-feature').addEventListener('click', () => {

    map.removeControl(layerDialog);
    layerDialog = null;
  });
}

async function handleUploadFeature(newFeature, featureId, context) {
  try {
    let response;
    if (context !== "edit") {
      response = await api.post('/map/feature/', newFeature);
    } else if (context === "edit") {
      response = await api.patch(`/map/feature/${featureId}/`, newFeature);
    }
    if (response.status !== 201 && response.status !== 200) throw new Error('Failed to save source');
  } catch (error) {
    logger.error('Error saving new source:', error);
    throw error;
  }
}

//**************************************************************************************
//**************************************************************************************
//Source Only Dialog
//**************************************************************************************
//**************************************************************************************

export async function generateSourceDialog(map, onClose) {

  // Fetch necessary data from the database
  const data = await fetchSourceParameters();
  const languages = await fetchLanguages();

  logger.log("Source Parameters: ", data);
  logger.log("Languages: ", languages);

  // Generate the HTML content for the dialog, including the is_enabled checkbox
  const dialogContent = `
    <div class="row">
      <button class="save-btn" type="button" style="position: absolute; top: 5px; right: 50px; cursor: pointer;" id="save-source"><i class="fas fa-save"></i></button>
      <button class="cancel-btn" type="button" style="position: absolute; top: 5px; right: 20px; cursor: pointer;" id="cancel-source"><i class="fas fa-times"></i></button>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="title">Title:</label>
      </div>
      <div class="col-75">
        <input type="text" id="title" name="title" required>
        <p class="error-message" id="title-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="description">Description:</label>
      </div>
      <div class="col-75">
        <textarea id="description" name="description" required></textarea>
        <p class="error-message" id="description-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="projection">Projection:</label>
      </div>
      <div class="col-75">
        <select id="projection" name="projection" required>
          <option value="">Select a projection</option>
          ${data.projection_systems.map(proj => `<option value="${proj.id}" data-title="${proj.title}">${proj.title}</option>`).join('')}
        </select>
        <p class="error-message" id="projection-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="type">Type:</label>
      </div>
      <div class="col-75">
        <select id="type" name="type" required>
          <option value="">Select a type</option>
          ${data.source_types.map(type => `<option value="${type.id}" data-title="${type.title}">${type.title}</option>`).join('')}
        </select>
        <p class="error-message" id="type-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="attribution">Attribution:</label>
      </div>
      <div class="col-75">
        <textarea id="attribution" name="attribution"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="is_enabled">Enabled:</label> <!-- Checkbox for "is_enabled" -->
      </div>
      <div class="col-75">
        <input type="checkbox" id="is_enabled" name="is_enabled" checked> <!-- Default to checked -->
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label>Source Options:</label>
      </div>
      <div class="col-75">
        <table id="source-options-table" style="width:100%;">
          <thead>
            <tr>
              <th>Option</th>
              <th>Value</th>
              <th>Delete?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3"><a href="#" id="add-source-option" style="color: white; text-decoration: none;">+ Add Source Option</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="viewers">Viewers:</label>
      </div>
      <div class="col-75 dual-listbox">
        <div class="listbox">
          <h4>Available Viewers</h4>
          <ul id="available-viewers"></ul>
        </div>
        <div class="listbox-buttons">
          <button type="button" id="add-viewer">&gt;</button>
          <button type="button" id="remove-viewer">&lt;</button>
        </div>
        <div class="listbox">
          <h4>Selected Viewers</h4>
          <ul id="selected-viewers"></ul>
        </div>
      </div>
    </div>
  `;

  // Create and show the dialog
  let sourceDialog = new Dialog({
    content: dialogContent,
    className: "source-dialog",
    closeBox: false,    
    onclose: () => {
      onClose();  // Ensure cleanup and UI state reset
    },
  });

  map.addControl(sourceDialog);
  sourceDialog.show();

  // Make the dialog draggable and resizable
  makeDialogDraggable(sourceDialog.element);
  makeDialogResizable(sourceDialog.element);

  // Event to add a new row for source options
  document.getElementById('add-source-option').addEventListener('click', (e) => {
    e.preventDefault();
    addSourceOptionRow();
  });

  function validateSourceInputs() {
    let errors = {};
    const title = document.getElementById('title').value.trim();
    const description = document.getElementById('description').value.trim();
    const projection = document.getElementById('projection').value.trim();
    const type = document.getElementById('type').value.trim();

    if (!title) errors.titleError = 'Title is required.';
    if (!description) errors.descriptionError = 'Description is required.';
    if (!projection) errors.projectionError = 'Projection must be selected.';
    if (!type) errors.typeError = 'Type must be selected.';

    return errors;
  }

  function displayErrors(errors) {
    document.getElementById('title-error').textContent = errors.titleError || '';
    document.getElementById('description-error').textContent = errors.descriptionError || '';
    document.getElementById('projection-error').textContent = errors.projectionError || '';
    document.getElementById('type-error').textContent = errors.typeError || '';
  }

  function addSourceOptionRow() {
    const table = document.getElementById('source-options-table').getElementsByTagName('tbody')[0];
    const row = table.insertRow(table.rows.length - 1); // Insert above the last row with the link
    const cell1 = row.insertCell(0);
    const cell2 = row.insertCell(1);
    const cell3 = row.insertCell(2);

    cell1.innerHTML = '<input type="text" name="optionName[]" placeholder="Option Name">';
    cell2.innerHTML = '<input type="text" name="optionValue[]" placeholder="Option Value">';
    cell3.innerHTML = '<button type="button" class="delete-option">Delete</button>';

    // Add event listener for the delete button
    cell3.querySelector('.delete-option').addEventListener('click', () => {
      row.remove();
    });
  }

  // Save button click handler to include "is_enabled" value
  document.getElementById('save-source').addEventListener('click', async () => {

    const errors = validateSourceInputs();

    if (Object.keys(errors).length > 0) {
      displayErrors(errors);
      return;
    }

    const projectionSelect = document.getElementById('projection');
    const projection = projectionSelect.value;

    const typeSelect = document.getElementById('type');
    const selectedTypeId = typeSelect.value;
    const selectedCategory = data.source_types.find(type => type.id === selectedTypeId);

    const optionNames = Array.from(document.getElementsByName('optionName[]')).map(input => input.value);
    const optionValues = Array.from(document.getElementsByName('optionValue[]')).map(input => input.value);

    const sourceOptions = optionNames.map((title, index) => ({ title, value: optionValues[index] }));

    if (!selectedCategory) {
      logger.error(`Type with ID ${selectedTypeId} not found.`);
      return;
    }

    const newSource = {
      title: document.getElementById('title').value,
      description: document.getElementById('description').value,
      projection: projection,
      type: selectedCategory.id,
      attribution: document.getElementById('attribution').value,
      viewers: Array.from(document.getElementById('selected-viewers').children).map(li => li.textContent),
      is_enabled: document.getElementById('is_enabled').checked, // Get checkbox value
      options: sourceOptions
    };

    logger.log("new source: ", JSON.stringify(newSource, null, 2));

    try {
      await handleAddSourceSave(newSource);
      map.removeControl(sourceDialog);
      if (onClose) onClose();

    } catch (error) {
      logger.error('Error saving new source:', error);
    }
  });

  // Cancel button click handler to close the dialog
  document.getElementById('cancel-source').addEventListener('click', () => {

    map.removeControl(sourceDialog);
    sourceDialog = null;
    if (onClose) onClose();
  });
};

// Edit Source //

export const generateEditSourceDialog = async (map, onClose, sourceId = null) => {
  const sources = await fetchSources(); // Fetch sources from database
  const sourceParameters = await fetchSourceParameters(); // Fetch source parameters (projection, types, etc.)
  // const languages = await fetchLanguages(); // Fetch languages if required

  // Find the vector source type
  const vectorSourceType = sourceParameters.source_types.find(type => type.title === "Vector (Vector)");

  // Filter the sources to include only vector sources
  const vectorSources = vectorSourceType
    ? sources.filter(source => source.type === vectorSourceType.id)
    : [];

  let selectedSource = null;

  // If editing, find the selected source by ID
  if (sourceId) {
    selectedSource = vectorSources.find(source => source.id === sourceId);
    logger.log("Selected edit source id:", sourceId);
  };

  // Create the dialog content with editable fields, including the checkbox for "is_enabled"
  const dialogContent = `
    <div class="row">
      <button class="save-btn" type="button" style="position: absolute; top: 5px; right: 50px; cursor: pointer;" id="save-edit-source"><i class="fas fa-save"></i></button>
      <button class="cancel-btn" type="button" style="position: absolute; top: 5px; right: 20px; cursor: pointer;" id="cancel-edit-source"><i class="fas fa-times"></i></button>
      <button class="delete-btn" type="button" style="position: absolute; top: 5px; left: 20px; cursor: pointer;" id="delete-edit-source"><i class="fas fa-trash"></i></button>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="source">Source:</label> <!-- This is the dropdown to select a source -->
      </div>
      <div class="col-75">
        <select id="source" name="source" required>
          <option value="" disabled selected>Select a source</option> <!-- Empty default option -->
          ${sources.map(source => `<option value="${source.id}" ${selectedSource && selectedSource.id === source.id ? 'selected' : ''}>${source.title}</option>`).join('')}
        </select>
        <p class="error-message" id="source-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="title">Title:</label> <!-- This input field allows the user to edit the title -->
      </div>
      <div class="col-75">
        <input type="text" id="title" name="title" value="${selectedSource ? selectedSource.title : ''}" placeholder="Edit Title">
        <p class="error-message" id="title-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="description">Description:</label>
      </div>
      <div class="col-75">
        <textarea id="description" name="description">${selectedSource ? selectedSource.description : ''}</textarea>
        <p class="error-message" id="description-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="projection">Projection:</label>
      </div>
      <div class="col-75">
        <select id="projection" name="projection" required>
          ${sourceParameters.projection_systems.map(proj => `<option value="${proj.id}" ${selectedSource && selectedSource.projection === proj.id ? 'selected' : ''}>${proj.title}</option>`).join('')}
        </select>
        <p class="error-message" id="projection-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="type">Type:</label>
      </div>
      <div class="col-75">
        <select id="type" name="type" required>
          ${sourceParameters.source_types.map(type => `<option value="${type.id}" ${selectedSource && selectedSource.type === type.id ? 'selected' : ''}>${type.title}</option>`).join('')}
        </select>
        <p class="error-message" id="type-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="attribution">Attribution:</label>
      </div>
      <div class="col-75">
        <textarea id="attribution" name="attribution">${selectedSource ? selectedSource.attribution : ''}</textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="is_enabled">Enabled:</label> <!-- Checkbox for "is_enabled" -->
      </div>
      <div class="col-75">
        <input type="checkbox" id="is_enabled" name="is_enabled" ${selectedSource && selectedSource.is_enabled ? 'checked' : ''}>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="options">Source Options:</label>
      </div>
      <div class="col-75">
        <table id="source-options-table" style="width:100%;">
          <thead>
            <tr>
              <th>Option</th>
              <th>Value</th>
              <th>Delete?</th>
            </tr>
          </thead>
          <tbody>
            ${selectedSource ? selectedSource.options.map(option => `
              <tr>
                <td><input type="text" name="optionName[]" value="${option.title}" placeholder="Option Name"></td>
                <td><input type="text" name="optionValue[]" value="${option.value}" placeholder="Option Value"></td>
                <td><button type="button" class="delete-option">Delete</button></td>
              </tr>
            `).join('') : ''}
            <tr>
              <td colspan="3"><a href="#" id="add-source-option" style="color: white; text-decoration: none;">+ Add Source Option</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="viewers">Viewers:</label>
      </div>
      <div class="col-75 dual-listbox">
        <div class="listbox">
          <h4>Available Viewers</h4>
          <ul id="available-viewers"></ul>
        </div>
        <div class="listbox-buttons">
          <button type="button" id="add-viewer">&gt;</button>
          <button type="button" id="remove-viewer">&lt;</button>
        </div>
        <div class="listbox">
          <h4>Selected Viewers</h4>
          <ul id="selected-viewers"></ul>
        </div>
      </div>
    </div>
  `;

  function validateEditSourceInputs() {
    let errors = {};
    const source = document.getElementById('source').value.trim();
    const title = document.getElementById('title').value.trim();
    const description = document.getElementById('description').value.trim();
    const projection = document.getElementById('projection').value.trim();
    const type = document.getElementById('type').value.trim();

    if (!source) errors.sourceError = 'Source must be selected.';
    if (!title) errors.titleError = 'Title is required.';
    if (!description) errors.descriptionError = 'Description is required.';
    if (!projection) errors.projectionError = 'Projection must be selected.';
    if (!type) errors.typeError = 'Type must be selected.';

    return errors;
  };

  function displayErrors(errors) {
    document.getElementById('source-error').textContent = errors.sourceError || '';
    document.getElementById('title-error').textContent = errors.titleError || '';
    document.getElementById('description-error').textContent = errors.descriptionError || '';
    document.getElementById('projection-error').textContent = errors.projectionError || '';
    document.getElementById('type-error').textContent = errors.typeError || '';
  };

  // Create the Dialog and show it on the map
  let editSourceDialog = new Dialog({
    content: dialogContent,
    className: "edit-layer",
    closeBox: false,
    onclose: () => {
      onClose();  // Ensure cleanup and UI state reset
    },
  });
  map.addControl(editSourceDialog);
  editSourceDialog.show();

  makeDialogDraggable(editSourceDialog.element);
  makeDialogResizable(editSourceDialog.element);

  // Add event listeners for adding and removing source options
  document.getElementById('add-source-option').addEventListener('click', (e) => {
    e.preventDefault();
    addSourceOptionRow();
  });

  function addSourceOptionRow() {
    const table = document.getElementById('source-options-table').getElementsByTagName('tbody')[0];
    const row = table.insertRow(table.rows.length - 1); // Insert above the last row with the link
    const cell1 = row.insertCell(0);
    const cell2 = row.insertCell(1);
    const cell3 = row.insertCell(2);

    cell1.innerHTML = '<input type="text" name="optionName[]" placeholder="Option Name">';
    cell2.innerHTML = '<input type="text" name="optionValue[]" placeholder="Option Value">';
    cell3.innerHTML = '<button type="button" class="delete-option">Delete</button>';

    // Add event listener for the delete button
    cell3.querySelector('.delete-option').addEventListener('click', () => {
      row.remove();
    });
  }

  // Event listener to populate form when a source is selected
  document.getElementById('source').addEventListener("change", (event) => {
    const selectedSourceId = event.target.value;
    const selectedSource = sources.find((src) => src.id === selectedSourceId);
    populateFormWithSource(selectedSource);
  });

  // Populate the form with the selected source's data
  const populateFormWithSource = (source) => {
    document.getElementById('title').value = source.title; // Update title field
    document.getElementById('description').value = source.description;
    document.getElementById('projection').value = source.projection;
    document.getElementById('type').value = source.type;
    document.getElementById('attribution').value = source.attribution;
    document.getElementById('is_enabled').checked = source.is_enabled; // Update the checkbox

    const optionsTable = document.getElementById('source-options-table').getElementsByTagName('tbody')[0];
    optionsTable.innerHTML = ''; // Clear previous options

    source.options.forEach(option => {
      const row = optionsTable.insertRow();
      const cell1 = row.insertCell(0);
      const cell2 = row.insertCell(1);
      const cell3 = row.insertCell(2);

      cell1.innerHTML = `<input type="text" name="optionName[]" value="${option.title}" placeholder="Option Name">`;
      cell2.innerHTML = `<input type="text" name="optionValue[]" value="${option.value}" placeholder="Option Value">`;
      cell3.innerHTML = `<button type="button" class="delete-option">Delete</button>`;

      cell3.querySelector('.delete-option').addEventListener('click', () => {
        row.remove();
      });
    });

    // Add a row for adding new options
    const addRow = optionsTable.insertRow();
    const addCell = addRow.insertCell(0);
    addCell.colSpan = 3;
    addCell.innerHTML = `<a href="#" id="add-source-option" style="color: white; text-decoration: none;">+ Add Source Option</a>`;
    document.getElementById('add-source-option').addEventListener('click', (e) => {
      e.preventDefault();
      addSourceOptionRow();
    });
  };

  // Populate the form initially if editing a source
  if (selectedSource) {
    populateFormWithSource(selectedSource);
  }

  // Save button click handler
  document.getElementById("save-edit-source").addEventListener("click", async () => {
    const errors = validateEditSourceInputs();

    if (Object.keys(errors).length > 0) {
      displayErrors(errors);
      return;
    }

    const selectedSourceId = document.getElementById("source").value; // Get selected source from dropdown
    const updatedSource = {
      title: document.getElementById("title").value,
      description: document.getElementById("description").value,
      projection: document.getElementById("projection").value,
      type: document.getElementById("type").value,
      attribution: document.getElementById("attribution").value,
      is_enabled: document.getElementById("is_enabled").checked,
      options: Array.from(document.getElementsByName('optionName[]')).map((nameField, index) => ({
        title: nameField.value,
        value: document.getElementsByName('optionValue[]')[index].value
      }))
    };

    try {
      await api.patch(`/map/source/${selectedSourceId}/`, updatedSource); // API call to update the source
      logger.log("Source updated successfully");

      map.removeControl(editSourceDialog);
      editSourceDialog = null;
      if (onClose) onClose();

    } catch (error) {
      logger.error("Error updating source:", error);
    }
  });

  // Cancel button click handler to close the dialog
  document.getElementById('cancel-edit-source').addEventListener('click', () => {

    map.removeControl(editSourceDialog);
    editSourceDialog = null;
    // Ensure external UI reset (optional but recommended)
    if (onClose) onClose();

    // Clean up any dynamic event listeners or elements
    const sourceDropdown = document.getElementById('source');
    if (sourceDropdown) {
      sourceDropdown.removeEventListener('change', populateFormWithSource);
    }
  });

  document.getElementById('delete-source')?.addEventListener('click', async () => {
    const selectedSourceId = document.getElementById("source").value; // Get the selected source ID dynamically
    if (!selectedSourceId) {
      logger.error("No source selected for deletion");
      return; // If no source is selected, do not proceed with the delete
    };

    // Show the confirmation dialog
    generateDeleteConfirmationDialog(map, async () => {
      try {
        // Send the DELETE request to the API
        await api.delete(`/map/source/${selectedSourceId}/`);
        logger.log("Source deleted successfully");

        map.removeControl(editSourceDialog);
        if (onClose) onClose();

      } catch (error) {
        logger.error("Error deleting source:", error); // Proper error logging
      }
    });
  });
};

// Function to handle saving the new source to the backend
async function handleAddSourceSave(newSource) {
  try {
    const response = await api.post('/map/source/', newSource);
    if (response.status !== 201 && response.status !== 200) throw new Error('Failed to save source');
  } catch (error) {
    logger.error('Error saving new source:', error);
    throw error;
  }
};

//**************************************************************************************
//**************************************************************************************
//Layer Only Dialog
//**************************************************************************************
//**************************************************************************************

//Functions for both Layer Dialogs
const updateLinePreview = () => {
  const selectedStyle = document.getElementById('line-style').value;
  const previewElement = document.getElementById('line-preview');
  previewElement.style.borderTopStyle = selectedStyle;
};

export async function generateLayerDialog(map, onClose) {

  // Fetch necessary data from the database
  const sources = await fetchSources();
  const sourceParameters = await fetchSourceParameters();

  const vectorSourceType = sourceParameters.source_types.find(type => type.title === "Vector (Vector)");

  const vectorSources = vectorSourceType
    ? sources.filter(source => source.type === vectorSourceType.id && source.is_enabled === true)
    : [];
 
  const optionsHtml = `
    <option value="" disabled selected>Choose a source</option>
    ${vectorSources
      .map(source => `<option value="${source.id}">${source.title}</option>`)
      .join('')}
  `;

  // const languages = await fetchLanguages();
  logger.log("Sources: ", sources);
  // const owners = [{ id: '230d187c-b557-4d1a-b4e6-482170984212', name: 'Admin' }];

  // Generate the HTML content for the dialog
  const dialogContent = `
    <div class="row">
      <button class="save-btn" type="button" style="position: absolute; top: 5px; right: 50px; cursor: pointer;" id="save-layer"><i class="fas fa-save"></i></button>
      <button class="cancel-btn" type="button" style="position: absolute; top: 5px; right: 20px; cursor: pointer;" id="cancel-layer"><i class="fas fa-times"></i></button>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="title">Title:</label>
      </div>
      <div class="col-75">
        <input type="text" id="title" name="title" required>
        <p class="error-message" id="title-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="description">Description:</label>
      </div>
      <div class="col-75">
        <textarea id="description" name="description" required></textarea>
        <p class="error-message" id="description-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="source">Source:</label>
      </div>
      <div class="col-75">
        <select id="source" name="source">
          ${optionsHtml}
        </select>
        <p class="error-message" id="source-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="is_enabled">Enabled:</label> <!-- Checkbox for "is_enabled" -->
      </div>
      <div class="col-75">
        <input type="checkbox" id="is_enabled" name="is_enabled" checked> <!-- Default to checked -->
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="icon">Icon:</label>
      </div>
      <div class="col-75">
        <input type="text" id="icon" name="icon" class="icon-picker" required style="flex: 1; width: 80%;">
        <p class="error-message" id="icon-error"></p>
        <span id="selected-icon-display" style="margin-left: 10px; font-size: 1.5em;" class="fas fa-user"></span>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="line-style">Line:</label>
      </div>
      <div class="col-75">
        <select id="line-style" name="line-style" style="flex: 1; width: 60%;">
          <option value="solid">Solid</option>
          <option value="dashed">Dashed</option>
          <option value="dotted">Dotted</option>
        </select>
        <span id="line-preview" style="display:inline-block; width:100px; height:2px; border-top:2px solid black; margin-left:10px; border-color:white;"></span>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="pattern">Pattern:</label>
      </div>
      <div class="col-75">
        <div id="pattern-picker">
          <div id="select" style="width:50px; height:40px; border:1px solid #fff; background-color: #fff;"></div>
          <div id="pselect" style="display:none; position: absolute; background:#fff; box-shadow:1px 1px 3px #000; grid-template-columns: repeat(4, 50px) !important; gap: 10px !important;"></div>
          <input type="hidden" id="pattern-input" value="hatch">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="color">Color:</label>
      </div>
      <div class="col-75">
        <input type="color" id="color" name="color" value="#3399FF" style="margin: 12px 12px 12px 0px !important;">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="background">Background:</label>
      </div>
      <div class="col-75">
        <input type="color" id="background" name="background" value="#FF335C" style="margin: 12px 12px 12px 0px !important;">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="opacity">Opacity:</label>
      </div>
      <div class="col-75">
        <input type="number" id="opacity" name="opacity" value="0.5" min="0" max="1" step="0.01" style="margin: 12px 12px 12px 0px !important;">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="image">Image:</label>
      </div>
      <div class="col-75">
        <input type="file" id="image" name="image" style="margin: 12px 12px 12px 0px !important;">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="viewers">Viewers:</label>
      </div>
      <div class="col-75 dual-listbox">
        <div class="listbox">
          <h4>Available Viewers</h4>
          <ul id="available-viewers"></ul>
        </div>
        <div class="listbox-buttons">
          <button type="button" id="add-viewer">&gt;</button>
          <button type="button" id="remove-viewer">&lt;</button>
        </div>
        <div class="listbox">
          <h4>Selected Viewers</h4>
          <ul id="selected-viewers"></ul>
        </div>
      </div>
    </div>
  `;

  //   <div class="row">
  //   <div class="col-25">
  //     <label for="language">Language:</label>
  //   </div>
  //   <div class="col-75">
  //     <select id="language" name="language">
  //       ${languages.map(language => `<option value="${language.id}">${language.title}</option>`).join('') || ''}
  //     </select>
  //   </div>
  // </div>

  function validateLayerInputs() {
    let errors = {};
    const title = document.getElementById('title').value.trim();
    const description = document.getElementById('description').value.trim();
    const source = document.getElementById('source').value.trim();
    const icon = document.getElementById('icon').value.trim();

    if (!title) errors.titleError = 'Title is required.';
    if (!description) errors.descriptionError = 'Description is required.';
    if (!source) errors.sourceError = 'Source must be selected.';
    if (!icon) errors.iconError = 'Icon is required.';

    return errors;
  };

  function displayErrors(errors) {
    document.getElementById('title-error').textContent = errors.titleError || '';
    document.getElementById('description-error').textContent = errors.descriptionError || '';
    document.getElementById('source-error').textContent = errors.sourceError || '';
    document.getElementById('icon-error').textContent = errors.iconError || '';
  };

  // Create and show the dialog
  let layerDialog = new Dialog({
    content: dialogContent,
    className: "layer-dialog",
    closeBox: false,
    onclose: () => {
      onClose();  // Ensure cleanup and UI state reset
    },
  });

  map.addControl(layerDialog);
  layerDialog.show();

  // Make the dialog draggable
  makeDialogDraggable(layerDialog.element);
  makeDialogResizable(layerDialog.element);  // Make it resizable

  // Event listeners for the dual listbox
  const availableViewers = document.getElementById('available-viewers');
  const selectedViewers = document.getElementById('selected-viewers');
  const addViewerButton = document.getElementById('add-viewer');
  const removeViewerButton = document.getElementById('remove-viewer');

  const viewers = []; // Placeholder viewers
  viewers.forEach(viewer => {
    const li = document.createElement('li');
    li.textContent = viewer.name;
    li.addEventListener('click', () => handleAddViewer(viewer));
    availableViewers.appendChild(li);
  });

  const handleAddViewer = (viewer) => {
    const li = document.createElement('li');
    li.textContent = viewer.name;
    li.addEventListener('click', () => handleRemoveViewer(viewer));
    selectedViewers.appendChild(li);
    availableViewers.removeChild(viewer.element);
  };

  const handleRemoveViewer = (viewer) => {
    const li = document.createElement('li');
    li.textContent = viewer.name;
    li.addEventListener('click', () => handleAddViewer(viewer));
    availableViewers.appendChild(li);
    selectedViewers.removeChild(viewer.element);
  };

  addViewerButton.addEventListener('click', () => {
    // Move selected items from available to selected
  });

  removeViewerButton.addEventListener('click', () => {
    // Move selected items from selected to available
  });


  $('#icon').iconpicker({
    placement: 'bottom',
    animation: false,
    selectedCustomClass: 'label label-success',
    defaultValue: 'fas fa-user' // Set default icon class
  });

  // Set the default icon display and input value on page load
  $('#selected-icon-display').attr('class', 'fas fa-user'); // Display the default icon
  $('#icon').val('fas fa-user'); // Set the input field value to the default icon class

  // Listen for the icon change event
  $('#icon').on('iconpickerSelected', function (event) {
    const selectedIcon = event.iconpickerValue; // Get the selected icon class
    $('#selected-icon-display').attr('class', selectedIcon); // Update the span to show the selected icon
    $('#icon').val(selectedIcon); // Ensure the input field value is updated
  });  

  document.getElementById('line-style').addEventListener('change', updateLinePreview);

  // Pattern Picker functionality
  const selectElement = document.getElementById('select');
  const pselectElement = document.getElementById('pselect');
  const patternInputElement = document.getElementById('pattern-input');

  const patterns = ["hatch", "crosses", "cross", "dot", "circle", "square", "tile", "line", "dash", "dashdot", "chaos", "rock", "rocks", "pines", "mixtree2", "mixtree", "pine2", "tree2", "tree", "scrub", "forest2", "forest", "vine", "wave", "reed", "swamp", "grass", "flooded", "clay", "breccia", "coal", "dolomite", "brick", "gravel", "conglomerate2", "conglomerate", "sand", "cemetry", "hexagon", "nylon", "caps", "woven"];

  let selectedPattern = patternInputElement.value || patterns[0]; // Use the existing pattern or default

  // Update the default pattern background
  selectElement.style.backgroundImage = `url(${new FillPattern({ pattern: selectedPattern }).getImage().toDataURL()})`;

  // Show pattern options when clicking the select element
  selectElement.addEventListener('click', () => {
    pselectElement.style.display = pselectElement.style.display === 'none' ? 'grid' : 'none';
  });

  // Populate the pattern options grid
  patterns.forEach(pattern => {
    const div = document.createElement('div');
    div.style.width = '50px';
    div.style.height = '40px';
    div.style.border = '1px solid #000';
    div.style.backgroundImage = `url(${new FillPattern({ pattern }).getImage().toDataURL()})`;

    div.addEventListener('click', () => {
      selectedPattern = pattern; // Update the selected pattern
      patternInputElement.value = pattern; // Update the hidden input value
      selectElement.style.backgroundImage = div.style.backgroundImage; // Update the visual pattern picker
      pselectElement.style.display = 'none'; // Hide the pattern options
    });

    pselectElement.appendChild(div);
  });


  document.getElementById('save-layer').addEventListener('click', async () => {
    const errors = validateLayerInputs();

    if (Object.keys(errors).length > 0) {
      displayErrors(errors);
      return;
    }

    const sourceSelect = document.getElementById('source');
    const selectedSourceId = sourceSelect.value;
    const selectedSource = sources.find(source => source.id === selectedSourceId);

    const selectedIcon = document.getElementById('icon').value;
    const selectedColor = document.getElementById('color').value;
    const selectedBackground = document.getElementById('background').value;
    const selectedOpacity = document.getElementById('opacity').value;
    const selectedLineStyle = document.getElementById('line-style').value;
    const selectedPattern = document.getElementById('pattern-input').value;
    const selectedImage = document.getElementById('image').files[0] || null; // Capture file correctly
    const isEnabled = document.getElementById('is_enabled').checked;

    const newLayer = {
      title: document.getElementById('title').value,
      description: document.getElementById('description').value,
      source: selectedSource.id,
      icon: selectedIcon,
      line: selectedLineStyle,
      pattern: selectedPattern,
      color: selectedColor,
      background: selectedBackground,
      opacity: selectedOpacity,
      image: selectedImage ? await convertImageToBase64(selectedImage) : null,
      is_enabled: isEnabled,
      viewers: Array.from(selectedViewers.children).map(li => li.textContent),
    };

    try {
      await handleAddLayerSave(newLayer);
      map.removeControl(layerDialog);
      layerDialog = null;
      if (onClose) onClose();

    } catch (error) {
      logger.error('Error saving new layer:', error);
    }
  });


  document.getElementById('cancel-layer').addEventListener('click', () => {

    map.removeControl(layerDialog);
    layerDialog = null;
    if (onClose) onClose();

  });
};

async function handleAddLayerSave(newLayer) {
  try {
    const response = await api.post('/map/layer/', newLayer);
    if (response.status !== 201 && response.status !== 200) throw new Error('Failed to save layer');
  } catch (error) {
    logger.error('Error saving new layer:', error);
    throw error;
  }
};

//Edit Layers

export const generateEditLayerDialog = async (map, onClose, layerId = null) => {
  const layers = await fetchLayers(); // Fetch layers from the database
  const sources = await fetchSources(); // Fetch sources from the database
  const sourceParameters = await fetchSourceParameters(); // Fetch parameters for layers (e.g., styles, etc.)

  // Identify the vector source type
  const vectorSourceType = sourceParameters.source_types.find(type => type.title === "Vector (Vector)");

  // Filter only vector sources
  const vectorSources = vectorSourceType
    ? sources.filter(source => source.type === vectorSourceType.id && source.is_enabled === true)
    : [];

  let selectedLayer = null;

  // If editing, find the selected layer by ID
  if (layerId) {
    selectedLayer = layers.find(layer => layer.id === layerId);
    logger.log("Selected edit layer id:", layerId);
  }

  // Create the dialog content with editable fields, including the checkbox for "is_enabled"
  const dialogContent = `
    <div class="row">
      <button class="save-btn" type="button" style="position: absolute; top: 5px; right: 50px; cursor: pointer;" id="save-edit-layer"><i class="fas fa-save"></i></button>
      <button class="cancel-btn" type="button" style="position: absolute; top: 5px; right: 20px; cursor: pointer;" id="cancel-edit-layer"><i class="fas fa-times"></i></button>
      <button class="delete-btn" type="button" style="position: absolute; top: 5px; left: 20px; cursor: pointer;" id="delete-layer"><i class="fas fa-trash"></i></button>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="layer">Layer:</label>
      </div>
      <div class="col-75">
        <select id="layer" name="layer" required>
          <option value="" disabled selected>Select a layer</option>
          ${layers.map(layer => `<option value="${layer.id}" ${selectedLayer && selectedLayer.id === layer.id ? 'selected' : ''}>${layer.title}</option>`).join('')}
        </select>
        <p class="error-message" id="layer-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="title">Title:</label>
      </div>
      <div class="col-75">
        <input type="text" id="title" name="title" value="${selectedLayer ? selectedLayer.title : ''}" placeholder="Edit Title">
        <p class="error-message" id="title-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="description">Description:</label>
      </div>
      <div class="col-75">
        <textarea id="description" name="description">${selectedLayer ? selectedLayer.description : ''}</textarea>
        <p class="error-message" id="description-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="source">Source:</label>
      </div>
      <div class="col-75">
        <select id="source" name="source" required>
          <option value="" disabled selected>Select a vector source</option>
          ${vectorSources.map(source => 
            `<option value="${source.id}" ${selectedLayer?.source === source.id ? 'selected' : ''}>${source.title}</option>`
          ).join('')}
        </select>
        <p class="error-message" id="source-error"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="is_enabled">Enabled:</label>
      </div>
      <div class="col-75">
        <input type="checkbox" id="is_enabled" name="is_enabled" ${selectedLayer && selectedLayer.is_enabled ? 'checked' : ''}>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="icon">Icon:</label>
      </div>
      <div class="col-75">
        <input type="text" id="icon" name="icon" class="icon-picker" required style="flex: 1; width: 80%;">
        <span id="selected-icon-display" style="margin-left: 10px; font-size: 1.5em;" class="${selectedLayer ? selectedLayer.icon : 'fas fa-user'}"></span>
      </div>
    </div>     
    <div class="row">
      <div class="col-25">
        <label for="line-style">Line Style:</label>
      </div>
      <div class="col-75">
        <select id="line-style" name="line-style" style="flex: 1; width: 60%;">
          <option value="solid" ${selectedLayer && selectedLayer.line === 'solid' ? 'selected' : ''}>Solid</option>
          <option value="dashed" ${selectedLayer && selectedLayer.line === 'dashed' ? 'selected' : ''}>Dashed</option>
          <option value="dotted" ${selectedLayer && selectedLayer.line === 'dotted' ? 'selected' : ''}>Dotted</option>
        </select>
        <span id="line-preview" style="display:inline-block; width:100px; height:2px; border-top:2px solid black; margin-left:10px; border-color:white;"></span>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="pattern">Pattern:</label>
      </div>
      <div class="col-75">
        <div id="pattern-picker">
          <div id="select" style="width:50px; height:40px; border:1px solid #fff; background-color: #fff;"></div>
          <div id="pselect" style="display:none; position: absolute; background:#fff; box-shadow:1px 1px 3px #000; grid-template-columns: repeat(4, 50px) !important; gap: 10px !important;"></div>
          <input type="hidden" id="pattern-input" value="${selectedLayer ? selectedLayer.pattern : 'hatch'}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="color">Color:</label>
      </div>
      <div class="col-75">
        <input type="color" id="color" name="color" value="${selectedLayer ? selectedLayer.color : '#3399FF'}">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="background">Background:</label>
      </div>
      <div class="col-75">
        <input type="color" id="background" name="background" value="${selectedLayer ? selectedLayer.background : '#FF335C'}">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="opacity">Opacity:</label>
      </div>
      <div class="col-75">
        <input type="number" id="opacity" name="opacity" min="0" max="1" step="0.01" value="${selectedLayer ? selectedLayer.opacity : '0.5'}">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="image">Image:</label>
      </div>
      <div class="col-75">
        <input type="file" id="image" name="image">
      </div>
    </div>
    <div class="row">
      <div class="col-25">
        <label for="viewers">Viewers:</label>
      </div>
      <div class="col-75 dual-listbox">
        <div class="listbox">
          <h4>Available Viewers</h4>
          <ul id="available-viewers"></ul>
        </div>
        <div class="listbox-buttons">
          <button type="button" id="add-viewer">&gt;</button>
          <button type="button" id="remove-viewer">&lt;</button>
        </div>
        <div class="listbox">
          <h4>Selected Viewers</h4>
          <ul id="selected-viewers"></ul>
        </div>
      </div>
    </div>
  `;

  function validateEditLayerInputs() {
    let errors = {};
    const layer = document.getElementById('layer').value.trim();
    const title = document.getElementById('title').value.trim();
    const description = document.getElementById('description').value.trim();
    const source = document.getElementById('source').value.trim();

    if (!layer) errors.layerError = 'Layer must be selected.';
    if (!title) errors.titleError = 'Title is required.';
    if (!description) errors.descriptionError = 'Description is required.';
    if (!source) errors.sourceError = 'Source must be selected.';

    return errors;
  };

  function displayErrors(errors) {
    document.getElementById('layer-error').textContent = errors.layerError || '';
    document.getElementById('title-error').textContent = errors.titleError || '';
    document.getElementById('description-error').textContent = errors.descriptionError || '';
    document.getElementById('source-error').textContent = errors.sourceError || '';
  };

  // Create the Dialog and show it on the map
  let editLayerDialog = new Dialog({
    content: dialogContent,
    className: "edit-layer",
    closeBox: false,
    onclose: () => {
      onClose();  // Ensure cleanup and UI state reset
    },
  });

  map.addControl(editLayerDialog);
  editLayerDialog.show();

  document.getElementById('line-style').addEventListener('change', updateLinePreview);
  updateLinePreview(); // Ensure correct preview on dialog load

  // Make the dialog draggable
  makeDialogDraggable(editLayerDialog.element);
  makeDialogResizable(editLayerDialog.element);  // Make it resizable

  // Add event listener to update the form when a layer is selected
  document.getElementById('layer').addEventListener('change', (event) => {
    const selectedLayerId = event.target.value;
    const selectedLayer = layers.find(layer => layer.id === selectedLayerId);
    populateFormWithLayer(selectedLayer);
  });

  // Icon Picker initialization
  $('#icon').iconpicker({
    placement: 'bottom',
    animation: false,
    selectedCustomClass: 'label label-success',
    defaultValue: selectedLayer ? selectedLayer.icon : 'fas fa-user' // Set default icon class
  });

  // Set the default icon display and input value on page load
  $('#selected-icon-display').attr('class', selectedLayer ? selectedLayer.icon : 'fas fa-user'); // Display the default icon
  $('#icon').val(selectedLayer ? selectedLayer.icon : 'fas fa-user'); // Set the input field value to the default icon class

  // Listen for the icon change event
  $('#icon').on('iconpickerSelected', function (event) {
    const selectedIcon = event.iconpickerValue; // Get the selected icon class
    $('#selected-icon-display').attr('class', selectedIcon); // Update the span to show the selected icon
    $('#icon').val(selectedIcon); // Ensure the input field value is updated
  });

  const populateFormWithLayer = (layer) => {
    document.getElementById('title').value = layer.title;
    document.getElementById('description').value = layer.description;
    document.getElementById('source').value = layer.source;
    $('#selected-icon-display').attr('class', layer.icon);
    $('#icon').val(layer.icon);
    document.getElementById('is_enabled').checked = layer.is_enabled;
    document.getElementById('line-style').value = layer.line;

    updateLinePreview(); //Call to reflect the change in preview

    document.getElementById('pattern-input').value = layer.pattern; // Update the hidden pattern input

    // Update the visual pattern picker (assuming '#select' is the visible element for the pattern)
    const patternElement = document.getElementById('select');
    const pattern = layer.pattern || 'hatch'; // Use 'hatch' as the default pattern
    patternElement.style.backgroundImage = `url(${new FillPattern({ pattern }).getImage().toDataURL()})`; // Update visible pattern
    document.getElementById('color').value = layer.color;
    document.getElementById('background').value = layer.background;
    document.getElementById('opacity').value = layer.opacity;
  };

  // Pattern Picker functionality
  const selectElement = document.getElementById('select');
  const pselectElement = document.getElementById('pselect');
  const patternInputElement = document.getElementById('pattern-input');

  const patterns = ["hatch", "crosses", "cross", "dot", "circle", "square", "tile", "line", "dash", "dashdot", "chaos", "rock", "rocks", "pines", "mixtree2", "mixtree", "pine2", "tree2", "tree", "scrub", "forest2", "forest", "vine", "wave", "reed", "swamp", "grass", "flooded", "clay", "breccia", "coal", "dolomite", "brick", "gravel", "conglomerate2", "conglomerate", "sand", "cemetry", "hexagon", "nylon", "caps", "woven"];

  // Set the selected pattern initially (from the hidden input value)
  let selectedPattern = patternInputElement.value || patterns[0];

  // Update the pattern picker visual based on the selected pattern
  selectElement.style.backgroundImage = `url(${new FillPattern({ pattern: selectedPattern }).getImage().toDataURL()})`;

  // Show the pattern options when the select element is clicked
  selectElement.addEventListener('click', () => {
    pselectElement.style.display = pselectElement.style.display === 'none' ? 'grid' : 'none';
  });

  // Populate the pattern options grid
  patterns.forEach(pattern => {
    const div = document.createElement('div');
    div.style.width = '50px';
    div.style.height = '40px';
    div.style.border = '1px solid #000';
    div.style.backgroundImage = `url(${new FillPattern({ pattern }).getImage().toDataURL()})`;

    // Handle pattern selection
    div.addEventListener('click', () => {
      selectedPattern = pattern; // Update the selected pattern
      patternInputElement.value = pattern; // Update the hidden input value
      selectElement.style.backgroundImage = div.style.backgroundImage; // Update the visual picker
      pselectElement.style.display = 'none'; // Hide the pattern options
    });

    pselectElement.appendChild(div);
  });

  // Populate the form initially if editing a layer
  if (selectedLayer) {
    populateFormWithLayer(selectedLayer);
  }

  // Save button click handler
  document.getElementById("save-edit-layer").addEventListener("click", async () => {
    const errors = validateEditLayerInputs();

    if (Object.keys(errors).length > 0) {
      displayErrors(errors);
      return;
    }

    const selectedLayerId = document.getElementById("layer").value;
    const imageFile = document.getElementById("image").files[0];

    const updatedLayer = {
      title: document.getElementById("title").value,
      description: document.getElementById("description").value,
      source: document.getElementById("source").value,
      icon: document.getElementById("icon").value,
      is_enabled: document.getElementById("is_enabled").checked,
      line: document.getElementById("line-style").value,
      pattern: document.getElementById("pattern-input").value,
      color: document.getElementById("color").value,
      background: document.getElementById("background").value,
      opacity: document.getElementById("opacity").value,
      image: imageFile ? await convertImageToBase64(imageFile) : null,
    };

    function validateImageFile(file) {
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (!file) return null;
      if (!validTypes.includes(file.type)) return 'Invalid file type. Only JPEG, PNG, and GIF are allowed.';
      if (file.size > 2 * 1024 * 1024) return 'File size exceeds 2MB limit.';
      return null;
    };

    const imageError = validateImageFile(imageFile);
    if (imageError) {
      errors.imageError = imageError;
    };

    try {
      await api.patch(`/map/layer/${selectedLayerId}/`, updatedLayer);
      logger.log("Layer updated successfully");

      map.removeControl(editLayerDialog);
      if (onClose) onClose();

    } catch (error) {
      logger.error("Error updating layer:", error);
    }
  });


  // Cancel button click handler
  document.getElementById("cancel-edit-layer").addEventListener("click", () => {

    map.removeControl(editLayerDialog);
    editLayerDialog = null;
    if (onClose) onClose();

  });

  // Event listener to delete the layer
  document.getElementById('delete-layer').addEventListener('click', async () => {
    const selectedLayerId = document.getElementById("layer").value;
    if (!selectedLayerId) {
      logger.error("No layer selected for deletion");
      return;
    }

    // Show the confirmation dialog
    generateDeleteConfirmationDialog(map, async () => {
      try {
        await api.delete(`/map/layer/${selectedLayerId}/`);
        logger.log("Layer deleted successfully");

        map.removeControl(editLayerDialog);
        if (onClose) onClose();

      } catch (error) {
        logger.error("Error deleting layer:", error);
      }
    });
  });
};

//Delete Dialog//

function generateDeleteConfirmationDialog(map, onDeleteConfirm, onClose) {

  // Create the HTML content for the confirmation dialog
  const dialogContent = `
    <div class="row">
      <div class="col-75">
        <p>Are you sure you want to delete this source?</p>
      </div>
    </div>
    <div class="row">
      <button class="confirm-btn" style="position: absolute; right: 100px; cursor: pointer;" id="confirm-delete"><i class="fas fa-check"></i> Confirm</button>
      <button class="cancel-btn" style="position: absolute; right: 20px; cursor: pointer;" id="cancel-delete"><i class="fas fa-times"></i> Cancel</button>
    </div>
  `;

  // Create and display the confirmation dialog
  let confirmDialog = new Dialog({
    content: dialogContent,
    className: "delete-dialog",
    closeBox: false,
  });

  map.addControl(confirmDialog);
  confirmDialog.show();

  // Make the dialog draggable
  makeDialogDraggable(confirmDialog.element);
  makeDialogResizable(confirmDialog.element);  // Make it resizable

  // Add event listener for the confirm button
  document.getElementById('confirm-delete').addEventListener('click', () => {

    map.removeControl(confirmDialog);
    onDeleteConfirm(); // Call the delete function if confirmed

  });

  // Add event listener for the cancel button
  document.getElementById('cancel-delete').addEventListener('click', () => {

    map.removeControl(confirmDialog);
    confirmDialog = null;

  });
};

// Function to convert image file to Base64
async function convertImageToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
